import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './FineInformation.module.scss'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import BackNextButtons from 'shared/components/BackNextButtons.jsx'
import FineNumber from './FineNumber'
import {
  fineNumberAction,
  paymentAmountAction,
  clearAllAction,
  screenLoadingAction,
  addFineAction,
  clearFineAction,
  paymentAmountFullAction,
  minPaymentAmountAction,
  fineOwingAction,
  caseSotIdAction,
  receiptDetailAction,
  fineTypeAction,
} from 'redux/actions'
import { getfineOweAmountAction } from 'redux/reducers/apiReducers/fineOweAmountReducer'
import { getServiceAvailableAction } from 'redux/reducers/apiReducers/serviceAvailableReducer'
import PrivacyStatement from './PrivacyStatement'
import BackAnchor from '../../../../shared/components/BackAnchor'
import axios from 'axios'
import moment from 'moment'

const FineInformationView = ({ t, i18n, setIsError }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [isHelperOpen, setIsHelperOpen] = useState(false)
  const [fineNumberValid, setFineNumberValid] = useState('')
  const [errMsg, setErrMsg] = useState('')
  const [fineNumberError, setFineNumberError] = useState('fine_information.fine_number_error')
  const [fineNumberJEINError, setFineNumberJEINError] = useState('')

  const { fineNumber, fines } = useSelector((state) => state.app)
  const [showPrivacyStatement, setShowPrivacyStatement] = useState(false)

  const [disableFlag, setDisableFlag] = useState(false)
  const [serviceFlag, setServiceFlag] = useState(false)

  const outageUrl = window.location.origin + '/services/outageservice/api/outage-events'

  const [outageStartDate, setOutageStartDate] = useState('')
  const [outageEndDate, setOutageEndDate] = useState('')
  const [outageActive, setOutageActive] = useState(false)
  const [outageRichTexts, setOutageRichTexts] = useState([])

  const warnEventUrl = window.location.origin + '/services/outageservice/api/warning-events'

  const [warningFlag, setWarningFlag] = useState(false)
  const [warningActive, setWarningActive] = useState(false)
  const [warningRichTexts, setWarningRichTexts] = useState([])
  const [warningServiceFlag, setWarningServiceFlag] = useState(false)
  const [warningStartDate, setWarningStartDate] = useState('')
  const [warningEndDate, setWarningEndDate] = useState('')

  const dateNow = moment().toDate()
  const [dateFlag, setDateFlag] = useState(false)

  const backNextProps = {
    prevText: t('fine_information.back'),
    // prevURL: `/${i18n.language}${t('routes.privacy_notice')}`,
    prevURL:
      i18n.language === 'fr'
        ? 'https://beta.novascotia.ca/fr/payer-une-amende-contravention'
        : 'https://beta.novascotia.ca/pay-fine-ticket',
    nextText: t('fine_information.next'),
    isNextDisabled: disableFlag,
  }

  const onAddFine = () => {
    try {
      if (checkCookiesEnabled()) {
        if (validateFields()) {
          setErrMsg('')
          dispatch(screenLoadingAction())
          dispatch(getServiceAvailableAction())
            .then((res) => {
              if (res['data']) {
                dispatch(getfineOweAmountAction({ caseNumber: fineNumber }))
                  .then((res) => {
                    if (
                      !res['validationFailureMessage'] &&
                      !isNaN(res['amountOwing']) &&
                      res['amountOwing'].toString().indexOf('.') !== -1
                    ) {
                      if (validateCASESOTExist(res['receiptDetail'])) {
                        setFineNumberValid(false)
                        setFineNumberError('fine_information.fine_number_exist')
                      } else {
                        handleFineProcess(res)
                        // if (res['paymentAdjustmentMessage'] && res['paymentAdjustmentMessage'].includes('Full payment must be made.')) {
                        //   processPaymentFullFine(res)
                        // } else {
                        //   fineNotFullProcess(res)
                        // }
                      }
                    } else {
                      setFineNumberValid(false)
                      setFineNumberJEINError(
                        i18n.language === 'en' ? res['validationFailureMessage'] : res['validationFailureMessageFr']
                      )
                    }
                    dispatch(screenLoadingAction())
                  })
                  .catch((e) => {
                    setFineNumberValid(false)
                    setFineNumberError('fine_information.service_not_available_error')
                    console.log(e)
                    dispatch(screenLoadingAction())
                  })
              } else {
                setErrMsg('fine_information.service_not_available_error')
                dispatch(screenLoadingAction())
              }
            })
            .catch((e) => {
              console.log(e)
              setErrMsg('fine_information.service_not_available_error')
              dispatch(screenLoadingAction())
            })
        }
      }
    } catch (e) {
      console.log(e)
      setFineNumberValid(false)
      setFineNumberError('fine_information.service_not_available_error')
    }
  }

  // const processPaymentFullFine = (res) => {
  //   try {
  //     dispatch(
  //       addFineAction({
  //         fineNumber,
  //         fineOwing: res['amountOwing'],
  //         paymentAmount: res['amountOwing'],
  //         minPaymentAmount: res['minimumPaymentAmount'],
  //         paymentAmountFull: true,
  //         caseSotId: res['caseSotId'],
  //         receiptDetail: res['receiptDetail'],
  //         fineType: res['caseSotValue'],
  //       })
  //     )
  //     dispatch(clearFineAction())
  //     dispatch(editFineNumberAction(''))
  //     history.push(`/${i18n.language}${t('routes.fine_owing_info')}`)
  //   } catch (e) {
  //     console.log(e)
  //     setIsError(true)
  //   }
  // }

  // const fineNotFullProcess = (res) => {
  //   dispatch(fineOwingAction(res['amountOwing'].toString()))
  //   dispatch(minPaymentAmountAction(res['minimumPaymentAmount'].toString()))
  //   dispatch(fineTypeAction(res['caseSotValue']))
  //   dispatch(receiptDetailAction(res['receiptDetail']))
  //   dispatch(caseSotIdAction(res['caseSotId']))
  //   history.push(`/${i18n.language}${t('routes.fine_owing_info')}`)
  // }

  const handleFineProcess = (res) => {
    if (res['paymentAdjustmentMessage'] && res['paymentAdjustmentMessage'].includes('Full payment must be made.')) {
      dispatch(
        addFineAction({
          fineNumber,
          fineOwing: res['amountOwing'],
          paymentAmount: res['amountOwing'],
          minPaymentAmount: res['minimumPaymentAmount'],
          paymentAmountFull: 'final',
          caseSotId: res['caseSotId'],
          receiptDetail: res['receiptDetail'],
          fineType: res['caseSotValue'],
        })
      )
      dispatch(paymentAmountFullAction('final'))
    } else {
      dispatch(paymentAmountFullAction(''))
    }
    dispatch(fineOwingAction(res['amountOwing'].toString()))
    dispatch(minPaymentAmountAction(res['minimumPaymentAmount'].toString()))
    dispatch(fineTypeAction(res['caseSotValue']))
    dispatch(receiptDetailAction(res['receiptDetail']))
    dispatch(caseSotIdAction(res['caseSotId']))
    history.push(`/${i18n.language}${t('routes.fine_owing_info')}`)
  }

  const validateFields = () => {
    try {
      let isFineNumberValid = false
      if (fineNumber === '') {
        setFineNumberValid(isFineNumberValid)
      } else {
        isFineNumberValid = validateFineNumber(fineNumber)
      }
      return isFineNumberValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateFineExist = (fine) => {
    try {
      return fines.find((fineInfo) => fineInfo.fineNumber === fine)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateCASESOTExist = (caseSOT) => {
    try {
      return fines.find((fineInfo) => fineInfo.caseSotId.includes(caseSOT) || caseSOT.includes(fineInfo.caseSotId))
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateFineNumber = (fine) => {
    let isFineNumberValid = false
    try {
      setFineNumberJEINError('')
      const regex = RegExp(/^\d+$/)
      if (fine !== '') {
        if (regex.test(fine)) {
          if (fine.length > 0) {
            if (validateFineExist(fine)) {
              setFineNumberValid(isFineNumberValid)
              setFineNumberError('fine_information.fine_number_exist')
            } else {
              isFineNumberValid = true
              setFineNumberValid(isFineNumberValid)
            }
          } else {
            setFineNumberValid(isFineNumberValid)
            setFineNumberError('fine_information.fine_number_less')
          }
        } else {
          setFineNumberValid(isFineNumberValid)
          setFineNumberError('fine_information.fine_number_invalid')
        }
      } else {
        setFineNumberValid(isFineNumberValid)
        setFineNumberError('fine_information.fine_number_error')
      }
      return isFineNumberValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const togglePrivacyStatement = useCallback((e) => {
    e.preventDefault()
    setShowPrivacyStatement((prevState) => !prevState)
  }, [])

  const privacyToggleIcon = useMemo(() => (showPrivacyStatement ? 'fa-minus' : 'fa-plus'), [showPrivacyStatement])

  const handleBackClick = () => {
    const backURL =
      i18n.language === 'fr' ? 'https://beta.novascotia.ca/fr/payer-une-amende-contravention' : 'https://beta.novascotia.ca/pay-fine-ticket'
    window.location.href = backURL
  }

  const sendGetRequest = async () => {
    try {
      const res = await axios.get(outageUrl)
      const events = res.data
      const now = moment().toDate()
      const activeTexts = []
      for (const event of events) {
        const services = event.services || ''
        const isServiceAffected = services.split(',').includes('PAYDOJFINE') || services.split(',').includes('ALLSERVICES')
        const startDate = moment(event.outageStart).toDate()
        const endDate = moment(event.outageEnd).toDate()
        const isDateInRange = now > startDate && now < endDate
        if (event.enabled === true && isServiceAffected && isDateInRange) {
          activeTexts.push(event.outageRichText)
          setOutageActive(true)
          setServiceFlag(true)
          setDateFlag(true)
          setDisableFlag(true)
        }
      }
      setOutageRichTexts(activeTexts)
    } catch (err) {
      console.error(err)
    }
  }

  const sendWarnGetRequest = async () => {
    try {
      const res = await axios.get(warnEventUrl)
      const events = res.data
      const now = moment().toDate()
      const activeWarnTexts = []
      for (const event of events) {
        const services = event.services || ''
        const isServiceAffected = services.split(',').includes('PAYDOJFINE') || services.split(',').includes('ALLSERVICES')
        const startDate = moment(event.warningStartDate).toDate()
        const endDate = moment(event.warningEndDate).toDate()
        const isDateInRange = now > startDate && now < endDate
        if (event.enabled === true && isServiceAffected && isDateInRange) {
          activeWarnTexts.push(event.warningMessageText)
          setWarningActive(true)
          setWarningServiceFlag(true)
          setWarningFlag(true)
        }
      }
      setWarningRichTexts(activeWarnTexts)
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    sendGetRequest()
    sendWarnGetRequest()
  }, [])

  const momentOutageStartDate = moment(outageStartDate).toDate()
  const momentOutageEndDate = moment(outageEndDate).toDate()
  const momentWarningStartDate = moment(warningStartDate).toDate()
  const momentWarningEndDate = moment(warningEndDate).toDate()

  useEffect(() => {
    if (dateNow > momentOutageStartDate && dateNow < momentOutageEndDate) {
      setDateFlag(true)
    }
  }, [momentOutageStartDate, momentOutageEndDate])

  useEffect(() => {
    if (dateNow > momentWarningStartDate && dateNow < momentWarningEndDate) {
      setWarningFlag(true)
    }
  }, [momentWarningStartDate, momentWarningEndDate])

  useEffect(() => {
    if (dateFlag && serviceFlag && outageActive) {
      setDisableFlag(true)
    }
  }, [dateFlag, serviceFlag, outageActive])

  window.onload = function () {
    dispatch(clearAllAction())
  }

  const isAuthenticated = useSelector((state) => state.authentication.authenticated)
  const [prevPage, setPrevPage] = useState('')

  useEffect(() => {
    try {
      if (localStorage.getItem('addAnotherFineClicked') === 'finePayment') {
        setPrevPage('routes.fine_owing_info')
        dispatch(clearFineAction())
      } else if (localStorage.getItem('addAnotherFineClicked') === 'reviewConfirm') {
        setPrevPage('routes.review_confirmation')
        dispatch(clearFineAction())
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [])

  const checkCookiesEnabled = () => {
    try {
      var cookieEnabled = navigator.cookieEnabled
      if (!cookieEnabled) {
        document.cookie = 'testcookie'
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1
        if (cookieEnabled) {
          return true
        } else {
          setErrMsg('privacy_notice.enable_cookies')
        }
      }
      return cookieEnabled
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  function Banner() {
    if (disableFlag === true) {
      return (
        <>
          {outageRichTexts.map((text, index) => (
            <div key={index} className="alert-medium" data-gtm-vis-first-on-screen-9622674_25="908" data-gtm-vis-total-visible-time-9622674_25="100" data-gtm-vis-has-fired-9622674_25="1" data-gtm-vis-first-on-screen-9622674_29="912" data-gtm-vis-total-visible-time-9622674_29="100" data-gtm-vis-has-fired-9622674_29="1">
              <p className="no-margin"><span>{text}</span></p>
            </div>
          ))}
        </>
      )
    }
    return null
  }

  function WarningBanner() {
    if (warningFlag === true && disableFlag === false && warningServiceFlag === true && warningActive === true) {
      return (
        <>
          {warningRichTexts.map((text, index) => (
            <div key={index} className="alert-medium" data-gtm-vis-first-on-screen-9622674_25="908" data-gtm-vis-total-visible-time-9622674_25="100" data-gtm-vis-has-fired-9622674_25="1" data-gtm-vis-first-on-screen-9622674_29="912" data-gtm-vis-total-visible-time-9622674_29="100" data-gtm-vis-has-fired-9622674_29="1">
              <p className="no-margin"><span>{text}</span></p>
            </div>
          ))}
        </>
      )
    }
    return null
  }

  const handleContinueAction = () => {
    if (localStorage.getItem('addAnotherFineClicked') === 'finePayment') {
      const fine = fines[fines.length - 1]
      dispatch(fineNumberAction(fine.fineNumber))
      dispatch(fineOwingAction(fine.fineOwing))
      dispatch(paymentAmountAction(fine.paymentAmount))
      dispatch(minPaymentAmountAction(fine.minPaymentAmount))
      dispatch(fineTypeAction(fine.fineType))
      dispatch(receiptDetailAction(fine.receiptDetail))
      dispatch(caseSotIdAction(fine.caseSotId))
    }
    history.push(`/${i18n.language}${t(prevPage)}`)
  }

  return (
    <div className="container">
      <BackAnchor backPath="routes.screening_question" />
      <div className="row">
        <div className="col-xs-12">
          <h1>{t('title')}</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <Banner />
          <WarningBanner />
          <h2>{t('fine_information.tell_us_about')}</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <p>{t('fine_information.this_information_can_be')}</p>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={
              i18n.language === 'en'
                ? 'https://support.novascotia.ca/services/pay-a-fine'
                : 'https://support.novascotia.ca/services/pay-a-fine-fr?_ga=2.136916464.1105794548.1606825995-1302773320.1606825995'
            }
          >
            {t('fine_information.read_more_and_find')}
          </a>
          <span>{t('fine_information.open_in_new_tab')}</span>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <FineNumber
            validateFineNumber={validateFineNumber}
            fineNumberError={fineNumberError}
            fineNumberValid={fineNumberValid}
            fineNumberJEINError={fineNumberJEINError}
            errMsg={errMsg}
            setIsError={setIsError}
          />
        </div>
      </div>
      <div className={styles['error_margin']} style={{ gap: '20px' }}>
        <BackNextButtons props={backNextProps} nextOnClick={onAddFine} />
        {fines.length > 0 && (
          <button className={['btn-lg btn-default-transparent']} style={{ margin: 0 }} onClick={handleContinueAction}>
            {t('fine_information.continue_without_adding_fine')}
          </button>
        )}
      </div>
      {errMsg && <i className="fa fa-exclamation-circle" aria-hidden="true" />}
      <div className="help-block">{t(errMsg)}</div>
      <div className="row" style={{ marginBottom: '2rem' }}>
        <div className="col-xs-12 col-lg-8">
          <hr />
          <br />
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <i
              aria-label={t('shared.error')}
              className="fa fa-lock fa-lg"
              aria-hidden="true"
              style={{ color: '#0058a4', marginTop: '3px' }}
            ></i>
            <a href="#" id="toggle-privacy-statement" onClick={togglePrivacyStatement}>
              {t('privacy_notice.how_we_protect_information')}
            </a>
            <i
              aria-label={t('shared.error')}
              className={`fa fa-lg ${privacyToggleIcon}`}
              aria-hidden="true"
              style={{ color: '#0058a4', marginTop: '3px' }}
            ></i>
          </div>
          {showPrivacyStatement && <PrivacyStatement />}
          <br />
          <hr />
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(FineInformationView)
